import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files directly
import en from './locales/en.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import it from './locales/it.json';

// Configure resources with each language file containing all namespaces
const resources = {
  en: {
    translation: en
  },
  de: {
    translation: de
  },
  fr: {
    translation: fr
  },
  es: {
    translation: es
  },
  it: {
    translation: it
  }
};

i18n
  // pass the i18n instance to react-i18next
  .use(initReactI18next)
  // init i18next
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    
    // react settings
    react: {
      useSuspense: false,
    }
  });

export default i18n;